export default {
  'users-groups.title': 'Manage User Groups',
  'users-groups.userExists': 'User Exists',
  'users-groups.form.selectUser': 'Select a User',
};
